import React from 'react';
import { useTheme } from './ThemeProvider';

// Sun/moon button for the navbar. Only shown on pages that support both themes.
export const ThemeToggle = ({ className = '' }) => {
  const { theme, isThemed, toggleTheme } = useTheme();
  if (!isThemed) return null;

  const isDark = theme === 'dark';
  const label = isDark ? 'Switch to light mode' : 'Switch to dark mode';

  return (
    <button
      type="button"
      onClick={toggleTheme}
      aria-label={label}
      title={label}
      className={`w-9 h-9 rounded-full flex items-center justify-center text-white/90 border border-white/25 hover:text-cyan-300 hover:border-cyan-300/70 focus:outline-none focus-visible:ring-2 focus-visible:ring-cyan-300 transition-colors ${className}`}
    >
      {isDark ? (
        <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" aria-hidden="true">
          <circle cx="12" cy="12" r="4" />
          <path strokeLinecap="round" d="M12 2v2m0 16v2M4.93 4.93l1.41 1.41m11.32 11.32l1.41 1.41M2 12h2m16 0h2M4.93 19.07l1.41-1.41m11.32-11.32l1.41-1.41" />
        </svg>
      ) : (
        <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" aria-hidden="true">
          <path strokeLinecap="round" strokeLinejoin="round" d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z" />
        </svg>
      )}
    </button>
  );
};

export default ThemeToggle;
